import Header, { MenuOptions } from "../../Global/Header/Header";
import classes from "./ExplorerClub.module.css";
import Footer from "../../Global/Footer/Footer";
import TripCards from "../../Global/Cards/TripCards";
import Svg1 from "./Svg1";
import Svg2 from "./Svg2";
import Svg3 from "./Svg3";
import Svg4 from "./Svg4";
import Svg5 from "./Svg5";
import Svg6 from "./Svg6";
import NewTripCards from "../../Global/Cards/newTripCards";

export const ExploreClubView = ({
  tripData
}) => {

  return (
    <>
      <div className="block min-h-[30vh] sm:h-auto">
        <img
          className="hidden sm:block w-full h-112 lg:h-full object-cover xs:h-34"
          src="https://static.wixstatic.com/media/174eab_58f58537550d4d7f8af51ce5a4fc3db4~mv2.png/v1/fill/w_1351,h_716,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/For%20Explorers%201.png"
          alt=""
        />
        
        <div className="absolute top-0 left-0 right-0  bg-[#f6dcdc] sm:bg-transparent">
          <Header activeTab={MenuOptions.EXPLORER_CLUB} />
        </div>
        <div className="sm:ms-6 lg:ms-20 lg:w-2/3 sm:absolute top-0 mt-28 lg:mt-36 left-0 right-0 flex flex-col items-center sm:block  bg-[#f6dcdc] sm:bg-transparent">
          <p
            className={
              "font-Aeonik text-4xl font-semibold sm:font-normal sm:text-3xl lg:text-6xl text-start text-black"
            }
          >
            Welcome to
          </p>
          <div className="flex flex-row">
            <p
              className={
                "font-Aeonik text-4xl font-semibold sm:font-normal sm:text-3xl lg:text-6xl text-orange-600"
              }
            >
              Explorers
            </p>
            <p
              className={
                "font-Aeonik text-4xl font-semibold sm:font-normal sm:text-3xl lg:text-6xl lg:ms-5 ms-2 text-black"
              }
            >
              Club
            </p>
          </div>
          <p className={"font-Aeonik lg:text-xl text-2xl mt-2 text-center sm:text-left mx-[4vw] sm:mx-0 lg:mt-3"}>Adventure is out there and so are we</p>
          <img
          className="sm:hidden"
          src="https://static.wixstatic.com/media/174eab_58f58537550d4d7f8af51ce5a4fc3db4~mv2.png/v1/fill/w_1351,h_716,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/For%20Explorers%201.png"
          alt=""
        />
        </div>        
      </div>
      <div className="mt-8">
        <p className={classes["perks-heading"]}>Perks of Explorers</p>
        <p className={classes["underline"]}>__________</p>
        <div className={classes["grid-perks"]}>
          <Svg1 />
          <Svg2 />
          <Svg3 />
          <Svg4 />
          <Svg5 />
          <Svg6 />
        </div>
        <p className={classes["perks-heading"]}>Upcoming Explorations</p>
        <p className={classes["underline"]}>__________</p>
        <NewTripCards tripData={tripData} />
        <div className={classes["after-card-margin"]}></div>
        <Footer />
      </div>
    </>
  );
};
